import React from 'react'
import Modal from './../../../../../components/modal/modal.component'
import Button from '../../../../../components/buttons/buttons.component'
import styled from 'styled-components'
import ModalTrip from './modal-trip.component'
import ModalTripPromotion from './modal-trip-promotion.component'
import { connect } from 'react-redux'
import { Creators as SiteCreators } from '../../../../../ducks/site/site'
import { toastActions } from '../../../../../actions'
import { bindActionCreators } from 'redux'
import { AdminTicketService } from './../../../../../services/admin-ticket.service'
import { ClientTicketService } from './../../../../../services/client-ticket.service'
import { PaymentStatus } from '../../../../../constants/ticket-sale.constants'
import FontAwesome from 'react-fontawesome'
import { breakpoints } from '../../../../../constants'
import FileSaver from 'file-saver'
import { tripsDirections } from '@constants'
import PixInfo from '../../../../../components/pix/pix-info.component'
class ClientTicketModalComponent extends React.Component {
	render() {
		const {
			user,
			isAdmin,
			tickets,
			pixData,
			onReturn,
			closeModal,
			sourceCall,
			isModalOpen,
			orderNumber,
			toastSuccess,
			promotionCoupon,
			hasTicketsToShow,
			isQRCodeModalOpen,
		} = this.props

		const resendTripData = () => {
			toastSuccess({ message: 'Os bilhetes foram enviados por e-mail' })
			if (isAdmin) {
				AdminTicketService.resendTripData(orderNumber)
			} else {
				ClientTicketService.resendTripData(orderNumber)
			}
		}

		const generateBpe = async (tickets) => {
			const firstTicket = tickets[0]
			const userId =
				firstTicket.buyerId !== null &&
				firstTicket.buyerId !== undefined &&
				firstTicket.buyerId !== ''
					? firstTicket.buyerId
					: user.id
			ClientTicketService.generateBpeFiles(orderNumber, userId)
		}
		const downloadBpe = async () => {
			const { showLoading, hideLoading, toastDanger } = this.props

			const error = () => {
				toastDanger({
					message: 'Não foi possível fazer o download dos arquivos.',
				})
				hideLoading()
			}

			showLoading()
			await generateBpe(tickets)
			tickets.map((f) => {
				const userId =
					f.buyerId !== null && f.buyerId !== undefined && f.buyerId !== ''
						? f.buyerId
						: user.id
				ClientTicketService.download(
					orderNumber,
					f.trackNumber,
					userId,
					'Checkin de Embarque'
				)
					.then((response) => {
						const { data } = response
						if (data)
							FileSaver.saveAs(
								data,
								`Checkin de Embarque ${f.passengerName.toUpperCase()}.png`
							)
					})
					.catch(() => error())
					.finally(() => hideLoading())

				ClientTicketService.download(
					orderNumber,
					f.trackNumber,
					userId,
					'Passagem DaBPE'
				)
					.then((response) => {
						const { data } = response
						if (data)
							FileSaver.saveAs(
								data,
								`Passagem DaBPE ${f.passengerName.toUpperCase()}.pdf`
							)
					})
					.catch(() => error())
					.finally(() => hideLoading())
			})
		}

		const renderFunction = hasTicketsToShow
			? renderTickets(
					tickets,
					onReturn,
					downloadBpe,
					resendTripData,
					promotionCoupon,
					sourceCall,
				user,
				isAdmin
			  )
			: renderNoTickets
		return (
			<React.Fragment>
				<Modal
					onClose={closeModal}
					isOpen={isModalOpen}
					title={<span className="orange">Informações da viagem</span>}>
					{renderFunction()}
				</Modal>
				<Modal
					onClose={closeModal}
					isOpen={isQRCodeModalOpen}
					title={<span className="orange">Pagamento PIX</span>}>
					<PixInfo
						pixImageQrCode={pixData.pixImageQrCode}
						pixValidity={pixData.pixValidity}
						pixEmv={pixData.pixEmv}
						provider={pixData.provider}
					/>
				</Modal>
			</React.Fragment>
		)
	}
}

function byDeparture({ departure }, ticket) {
	return departure.localeCompare(ticket.departure)
}

function byBusSeat({ busSeatNumber }, ticket) {
	return busSeatNumber.localeCompare(ticket.busSeatNumber)
}

function isReturnTripOBSOLETE(ticketsGoing, ticket) {
	return !!ticketsGoing.filter(
		(ticketGoing) => ticketGoing.origin === ticket.destination
	).length
}

// TODO: criar selectors
function renderTickets(
	tickets,
	onReturn,
	downloadBpe,
	resendTripData,
	promotionCoupon,
	sourceCall,
	user
) {
	const sortedTickets = tickets.sort(byDeparture)

	let ticketsGoing = []
	let ticketsReturn = []

	sortedTickets.map((ticket) => {
		if (
			(!ticket.trecho && !isReturnTripOBSOLETE(ticketsGoing, ticket)) ||
			ticket.trecho === tripsDirections.IDA
		) {
			ticketsGoing.push(ticket)
		} else {
			ticketsReturn.push(ticket)
		}
	})

	let firstTicket = ticketsGoing[0]
	let lastTicket = sortedTickets[sortedTickets.length - 1]
	let hasReturnTrip = !!ticketsReturn.length
	let hasFamilyDiscount = firstTicket.familyDiscount == 'true'

	const now = new Date()
	const validateCanSend = (tickets, ticket) =>
		now <= new Date(ticket.departure) &&
		tickets.some((ticket) => ticket.canReturn)
	const canResend =
		(ticketsReturn.length && validateCanSend(ticketsReturn, lastTicket)) ||
		validateCanSend(ticketsGoing, firstTicket)
	return () => (
		<React.Fragment>
			<ModalTrip
				user={user}
				onReturn={onReturn}
				tickets={ticketsGoing}
				sourceCall={sourceCall}
				isGoing={true}
			/>
			{hasReturnTrip && <br />}
			{hasReturnTrip && (
				<ModalTrip
					onReturn={onReturn}
					tickets={ticketsReturn}
					sourceCall={sourceCall}
					isGoing={false}
				/>
			)}
			{firstTicket.status === PaymentStatus.ACTIVE && (
				<ModalTripPromotion promotionCoupon={promotionCoupon} />
			)}
			{hasFamilyDiscount ? (
				<div style={{ fontSize: '15px', margin: '10px' }}>
					<b>Observações: </b>
					<span>O Desconto Família foi aplicado nesta compra.</span>
				</div>
			) : null}
			<StyledFooterButtons>
				{canResend ? (
					<StyledButtonContainer>
						<Button primary type="button" onClick={resendTripData}>
							Enviar por e-mail
						</Button>
					</StyledButtonContainer>
				) : null}
				<Button secondary type="button" onClick={downloadBpe}>
					<span style={{ marginRight: 5 }}>
						<FontAwesome name="qrcode" size="lg" />
					</span>
					<span style={{ marginRight: 5 }}>
						<FontAwesome name="download" size="lg" />
					</span>
					Salvar Passagem(ns) Digital(is)
				</Button>
			</StyledFooterButtons>
		</React.Fragment>
	)
}

const StyledButtonContainer = styled.div`
	display: flex;
	justify-content: flex-end;
	margin-left: 10px;

	@media screen and (max-width: ${breakpoints.MOBILE}px) {
		margin-left: 0px;
	}
`
const StyledFooterButtons = styled.div`
	display: flex;
	justify-content: space-between;
	flex-direction: row-reverse;

	@media screen and (max-width: ${breakpoints.MOBILE}px) {
		font-size: 1.4rem;
		display: block;
		margin: 0;
		button {
			margin: 10px 0 0 0;
		}
	}
`

function renderNoTickets() {
	return (
		<div>
			<span>
				Parece que algo deu errado e seu bilhete de passagem não foi gerado.
			</span>
			<br></br>
			<span>Não se preocupe, a compra não será cobrada.</span>
			<br></br>
			<span>
				Em caso de qualquer dúvida em relação a sua compra, envie e-mail
				para{' '}
				<a href="mailto:faleconosco@muviflex.com.br?Subject=Fale conosco - Muviflex site">
					faleconosco@muviflex.com.br
				</a>
			</span>
		</div>
	)
}

const mapStateToProps = ({ clientTicketModal, user }) => ({
	orderNumber: clientTicketModal.orderNumber,
	user,
})

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			toastSuccess: toastActions.success,
			toastDanger: toastActions.danger,
			hideLoading: SiteCreators.hideLoading,
			showLoading: SiteCreators.showLoading,
		},
		dispatch
	)

const ClientTicketModal = connect(
	mapStateToProps,
	mapDispatchToProps
)(ClientTicketModalComponent)

export default ClientTicketModal
